import React from "reactn"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { JsonLd } from './jsonLd'
import { HelmetDatoCms } from "gatsby-source-datocms"

export function Seo({
  metaTitle = "INGMARSON",
  metaImage,
  socialImage,
  socialImages,
  metaDescription,
  location,
  path,
  productImage,
  seoMetaTags,
  og_type = "website"
}
) {
  const {
    site: { siteMetadata },
  } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteTitle
          siteTitleDefault
          siteUrl
          siteLogo
          hrefLang
          siteDescription
          siteImage
          siteImageWidth
          siteImageHeight
          siteImage1
          siteImageWidth1
          siteImageHeight1
          twitter
        }
      }
    }
  `)


  const {
    siteTitleDefault,
    siteImageHeight,
    siteLogo,
    siteUrl,
    siteDescription,
    siteImage,
    siteImage1,
    siteImageWidth1,
    siteImageHeight1,
    twitter,
  } = siteMetadata


  const seo = {
    title: metaTitle || siteTitleDefault,
    description: metaDescription || siteDescription,
    url: (siteUrl + (path ? path : location.pathname)).replace(/\/$/, ''),
    image: productImage ? siteUrl + '/static/' + productImage + ".jpg" : metaImage && metaImage.gatsbyImageData.images.fallback.src || socialImage || siteUrl + siteImage,
    images: socialImages ? JSON.parse(socialImages) : [],
    imageWidth: productImage ? 1200 : metaImage && metaImage.gatsbyImageData.width || 1200,
    imageHeight: productImage ? 630 : metaImage && metaImage.gatsbyImageData.height || 630,
    image1: siteUrl + siteImage1,
    imageWidth1: siteImageWidth1,
    imageHeight1: siteImageHeight1
  }
  console.log("SEO IMaGE", seo.image)
  return (
    <>
      {seoMetaTags &&
        <HelmetDatoCms seo={seoMetaTags} />
      }

      {!seoMetaTags &&
        <Helmet lang="en">
          <meta property="og:image:secure_url" content={seo.image} />
          <meta property="og:image" content={seo.image} />
          <meta property="og:site_name" content={seo.title} />
          <meta property="og:description" content={seo.description} />
          <meta property="og:image:width" content={seo.imageWidth} />
          <meta property="og:image:height" content={seo.imageHeight} />
          <meta itemprop="name" content={seo.title} />
          <title>{seo.title}</title>
          <meta itemprop="description" content={seo.description} />
          <meta itemprop="image" content={seo.image} />
          <link rel="image_src" href={seo.image} />
          <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#000000" />
          <meta name="msapplication-TileColor" content="#ffffff" />
          <meta name="description" content={seo.description} />
          <meta name="image" content={seo.image} />
          <meta property="og:title" content={seo.title} />
          <meta property="og:url" content={seo.url} />
          <meta property="og:image" content={seo.image} />
          <meta name="twitter:description" content={seo.description} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={seo.title} />
          <meta name="twitter:url" content={seo.url} />
          <meta name="twitter:site" content={twitter} />
          <meta name="twitter:creator" content={twitter} />
        </Helmet>
      }

      <Helmet
        htmlAttributes={{ lang: 'en' }}
      >
        <link rel='canonical' key={seo.url} href={seo.url} />
        <html lang={"en"} />
        <meta property="og:url" content={seo.url} />
        <meta property="og:type" content={og_type} />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/favicon-16x16.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/apple-touch-icon.png"
        />
      </Helmet>
      <JsonLd >
        {[
          {
            '@context': 'http://schema.org',
            '@type': 'WebSite',
            url: siteUrl,
            name: 'INGMARSON'
          },
          {
            '@context': 'http://schema.org',
            '@type': 'WebPage',
            url: seo.url,
            name: seo.title,
            alternateName: 'INGMARSON',
            primaryImageOfPage: [{
              '@type': 'ImageObject',
              url: seo.image,
              height: seo.imageWidth,
              width: seo.imageWidth
            },
            {
              '@type': 'ImageObject',
              url: seo.image1,
              height: seo.imageWidth1,
              width: seo.imageWidth1
            }
            ]
          },
          {
            "@context": "http://schema.org",
            "@type": "LocalBusiness",
            name: "INGMARSON",
            "address": {
              "@type": "PostalAddress",
              addressLocality: 'London, UK',
              postalCode: 'N1 4PR',
              streetAddress: '84a Mildmay Park',
              addressRegion: 'Islington'
            },
            telephone: '(+44) 800 4643617',
            priceRange: "£30 - £200",
            url: siteUrl,
            logo: siteUrl + siteLogo,
            image: {
              '@type': 'ImageObject',
              url: siteUrl + siteImage,
              height: siteImageHeight,
              width: siteImageHeight
            },
          },
          {
            '@context': 'http://schema.org',
            '@type': 'Organization',
            sameAs: 'https://www.instagram.com/ingmarson_london/',
            sameAs: 'https://www.facebook.com/INGMARSONLondon/',
            sameAs: 'https://twitter.com/INGMARSON_Lnd',
            image: {
              '@type': 'ImageObject',
              url: siteUrl + siteImage,
              height: siteImageHeight,
              width: siteImageHeight
            },
            logo: siteUrl + siteLogo,
            "address": {
              "@type": "PostalAddress",
              addressLocality: 'London, UK',
              postalCode: 'N1 4PR',
              streetAddress: '84a Mildmay Park',
              addressRegion: 'Islington'
            },
            "brand": {
              "@type": "Brand",
              "logo": siteUrl + siteLogo,
              "name": "INGMARSON",
              "url": siteUrl
            },
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '(+44) 800 4643617',
              contactType: 'Customer service'
            },
            url: siteUrl,
            name: "INGMARSON"
          }
        ]
        }
      </JsonLd>
    </>
  )
}

